import { COUNTRY_US, COUNTRY_UK, COUNTRY_IRELAND } from './utils/countries';

export const KEYCODE_ENTER = 13;

// US States (Province IDs 1-50)
export const STATES = [
    {value: 'AL', display: 'Alabama', id: 1},
    {value: 'AK', display: 'Alaska', id: 2},
    {value: 'AZ', display: 'Arizona', id: 3},
    {value: 'AR', display: 'Arkansas', id: 4},
    {value: 'CA', display: 'California', id: 5},
    {value: 'CO', display: 'Colorado', id: 6},
    {value: 'CT', display: 'Connecticut', id: 7},
    {value: 'DE', display: 'Delaware', id: 8},
    {value: 'DC', display: 'District of Columbia', id: 9},
    {value: 'FL', display: 'Florida', id: 10},
    {value: 'GA', display: 'Georgia', id: 11},
    {value: 'HI', display: 'Hawaii', id: 12},
    {value: 'ID', display: 'Idaho', id: 13},
    {value: 'IL', display: 'Illinois', id: 14},
    {value: 'IN', display: 'Indiana', id: 15},
    {value: 'IA', display: 'Iowa', id: 16},
    {value: 'KS', display: 'Kansas', id: 17},
    {value: 'KY', display: 'Kentucky', id: 18},
    {value: 'LA', display: 'Louisiana', id: 19},
    {value: 'ME', display: 'Maine', id: 20},
    {value: 'MD', display: 'Maryland', id: 21},
    {value: 'MA', display: 'Massachusetts', id: 22},
    {value: 'MI', display: 'Michigan', id: 23},
    {value: 'MN', display: 'Minnesota', id: 24},
    {value: 'MS', display: 'Mississippi', id: 25},
    {value: 'MO', display: 'Missouri', id: 26},
    {value: 'MT', display: 'Montana', id: 27},
    {value: 'NE', display: 'Nebraska', id: 28},
    {value: 'NV', display: 'Nevada', id: 29},
    {value: 'NH', display: 'New Hampshire', id: 30},
    {value: 'NJ', display: 'New Jersey', id: 31},
    {value: 'NM', display: 'New Mexico', id: 32},
    {value: 'NY', display: 'New York', id: 33},
    {value: 'NC', display: 'North Carolina', id: 34},
    {value: 'ND', display: 'North Dakota', id: 35},
    {value: 'OH', display: 'Ohio', id: 36},
    {value: 'OK', display: 'Oklahoma', id: 37},
    {value: 'OR', display: 'Oregon', id: 38},
    {value: 'PA', display: 'Pennsylvania', id: 39},
    {value: 'RI', display: 'Rhode Island', id: 40},
    {value: 'SC', display: 'South Carolina', id: 41},
    {value: 'SD', display: 'South Dakota', id: 42},
    {value: 'TN', display: 'Tennessee', id: 43},
    {value: 'TX', display: 'Texas', id: 44},
    {value: 'UT', display: 'Utah', id: 45},
    {value: 'VT', display: 'Vermont', id: 46},
    {value: 'VA', display: 'Virginia', id: 47},
    {value: 'WA', display: 'Washington', id: 48},
    {value: 'WV', display: 'West Virginia', id: 49},
    {value: 'WI', display: 'Wisconsin', id: 50},
    {value: 'WY', display: 'Wyoming', id: 51}
];

// UK Regions (Province IDs 64-67)
export const UK_REGIONS = [
    {value: 'ENG', display: 'England', id: 64},
    {value: 'SCT', display: 'Scotland', id: 65},
    {value: 'WLS', display: 'Wales', id: 66},
    {value: 'NIR', display: 'Northern Ireland', id: 67}
];

// Ireland Counties (Province IDs 68-93)
export const IRELAND_COUNTIES = [
    {value: 'CW', display: 'Carlow', id: 68},
    {value: 'CN', display: 'Cavan', id: 69},
    {value: 'CE', display: 'Clare', id: 70},
    {value: 'C', display: 'Cork', id: 71},
    {value: 'DL', display: 'Donegal', id: 72},
    {value: 'D', display: 'Dublin', id: 73},
    {value: 'G', display: 'Galway', id: 74},
    {value: 'KY', display: 'Kerry', id: 75},
    {value: 'KE', display: 'Kildare', id: 76},
    {value: 'KK', display: 'Kilkenny', id: 77},
    {value: 'LS', display: 'Laois', id: 78},
    {value: 'LM', display: 'Leitrim', id: 79},
    {value: 'LK', display: 'Limerick', id: 80},
    {value: 'LD', display: 'Longford', id: 81},
    {value: 'LH', display: 'Louth', id: 82},
    {value: 'MO', display: 'Mayo', id: 83},
    {value: 'MH', display: 'Meath', id: 84},
    {value: 'MN', display: 'Monaghan', id: 85},
    {value: 'OY', display: 'Offaly', id: 86},
    {value: 'RN', display: 'Roscommon', id: 87},
    {value: 'SO', display: 'Sligo', id: 88},
    {value: 'TA', display: 'Tipperary', id: 89},
    {value: 'WD', display: 'Waterford', id: 90},
    {value: 'WH', display: 'Westmeath', id: 91},
    {value: 'WX', display: 'Wexford', id: 92},
    {value: 'WW', display: 'Wicklow', id: 93}
];

// Lookup regions by country ID
export var REGIONS_BY_COUNTRY = {};
REGIONS_BY_COUNTRY[COUNTRY_US] = STATES;
REGIONS_BY_COUNTRY[COUNTRY_UK] = UK_REGIONS;
REGIONS_BY_COUNTRY[COUNTRY_IRELAND] = IRELAND_COUNTIES;

/**
 * Get regions/provinces for a given country
 * @param {number} countryId - ISO country code
 * @returns {Array} - Array of region objects with value, display, id
 */
export var getRegionsForCountry = function(countryId) {
    return REGIONS_BY_COUNTRY[countryId] || STATES;
};

/**
 * Get the label for region dropdown based on country
 * @param {number} countryId - ISO country code
 * @returns {string} - "State", "Region", or "County"
 */
export var getRegionLabel = function(countryId) {
    if (countryId === COUNTRY_UK) return 'Region';
    if (countryId === COUNTRY_IRELAND) return 'County';
    return 'State';
};
